import { DEFAULT_LAYOUT_ID } from '@src/components/AppLayout/Layouts/tokens';
import { getTradingOrderDetailsRoute } from '@src/containers/Routes/routes';
import { getDisplayIdFromValue, getOrderStatusText, Order } from '@talos/kyoko';
import type { AppNotification } from '../AppNotificationsMonitorContainer';
import { appNotificationSeverityToToastVariant } from '../appNotificationSeverityToToastVariant';
import type { NotificationTransformerFn } from '../getNotificationRenderInfo';

export const resolveOrderStatusTargetUrl = (notification: AppNotification, layoutId: string | undefined) => {
  const order = new Order(notification.Payload as Order);
  return getTradingOrderDetailsRoute({
    layoutId: layoutId ?? DEFAULT_LAYOUT_ID,
    type: 'order',
    orderID: order.OrderID,
    tab: 'details',
  });
};

export const OrderStatusNotificationTransformer: NotificationTransformerFn = notification => {
  const order = new Order(notification.Payload as Order);

  return {
    appInboxToastType: 'OrderStatus',
    variant: appNotificationSeverityToToastVariant(notification.Severity),
    title: `Order ${getOrderStatusText({ type: 'order', order, isCustomerOrder: false })}`,
    description: `Order ${getDisplayIdFromValue(order.OrderID)} for ${notification.Payload.Symbol}`,
    targetUrlResolver: layoutId => resolveOrderStatusTargetUrl(notification, layoutId),
  };
};
